<template>
  <div class="container">
    <div class="wrap">
      <div class="page-t">摄影课程</div>
      <div class="page-b z-flex" v-if="false">
        <div 
          :class="['item',activeCate==item.value?'active':'']" 
          v-for="(item,index) in categoryList" 
          :key="index"
          @click="selCategory(item)"
        >
          {{item.name}}
        </div>
      </div>
      <div class="list-con">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item,index) in list" :key="index">
            <courseItem :itemData="item"></courseItem>
          </el-col>
        </el-row>
        <!-- 结果为空 -->
        <el-empty class="empty-con" description="暂无课程推荐" :image-size="180" v-if="list.length == 0">
          <img class="img" src="../assets/images/default-list.png" slot="image"/>
        </el-empty>
        <!-- 分页 -->
        <el-pagination 
          class="pagination" 
          background 
          layout="prev, pager, next" 
          :total="totalNum"
          :page-size="pageSize"
          hide-on-single-page
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import courseItem from '@/components/item/courseItem';
export default {
  components: {
    courseItem,
  },
  data() {
    return {
      curPage:1,
      pageSize: 20,
      totalNum:0,
      activeCate:'0',
      categoryList:[
        {
          value:'0',
          name:'全部',
        }
      ],
      list:[
        // {
        //   id:1,
        //   img:'http://edu.pai2345.com/storage/images/HdU4L4w2m5IMevqFX1DLSvszwThV6vQYoS5BR0WI.jpeg',
        //   title:'自然光美食摄影课-从入门到精通',
        //   category: '随到随学|系列课',
        //   viewNum: 0,
        // }
      ],
    };
  },
  computed: {
    
  },
  mounted() {
    this.getRows();
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    selCategory(item){
      this.activeCate = item.value;
      this.curPage = 1;
      this.getRows();
    },
    //分页
    changePage(e){
      this.curPage = e;
      this.getRows();
    },
    //获取列表数据
    getRows(){
      const loading = this.$loading({target:'.list-con',});
      let params = {page: this.curPage, pageSize: this.pageSize, cate: this.activeCate};
      this.$axios.api.eduCourseList(params, (res) => {
        if (res.code == 200) {
          loading.close();
          this.totalNum = res.data.total;
          this.list = res.data.list;
          if (this.categoryList.length == 1) {
            this.categoryList = this.categoryList.concat(res.data.categoryList);
          }
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap{
  align-items: flex-start;
}

</style>
